import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const FILES_BASE = `${BACKEND_URL}/api/files`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token also via Authorization header if we have it (mobile Safari cookie fallback)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("casarent_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Error inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

export function fileUrl(id) {
  if (!id) return null;
  return `${FILES_BASE}/${id}`;
}

// Miniatura reducida (?thumb=1) para tarjetas/listas -- el backend genera un
// JPEG pequeño al subir la foto y cae al original si no la encuentra, así
// que siempre es seguro usar esto donde solo hace falta un recuadro chico.
// Para la vista ampliada (lightbox/galería) usa fileUrl() a secas.
export function fileThumbUrl(id) {
  if (!id) return null;
  return `${FILES_BASE}/${id}?thumb=1`;
}

// URL pública del logo actual de la app (favicon, manifest, pantalla de login).
// No requiere auth. `v` (normalmente el logo_file_id) es solo cache-buster:
// cambia cada vez que se sube un logo nuevo, así el navegador no sirve el viejo.
export function logoUrl(v) {
  return `${API_BASE}/public/logo${v ? `?v=${encodeURIComponent(v)}` : ""}`;
}
